import { suggestActionsStaticData } from "@/src/common/business-layer/constants"
import ArrowListIcon from "@/src/sb/components/icon/ArrowListIcon"
import { useRouter } from "next/router"
import { Fragment, useState } from "react"
import { useHotkeys } from "react-hotkeys-hook"

const SuggestedAction = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)

  useHotkeys("arrowdown", () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === null
        ? 0
        : Math.min(prevIndex + 1, suggestActionsStaticData.length - 1)
    )
  })

  useHotkeys("arrowup", () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === null
        ? suggestActionsStaticData.length - 1
        : Math.max(prevIndex - 1, 0)
    )
  })

  useHotkeys("enter", () => {
    if (selectedIndex !== null) {
      const selectedItem = suggestActionsStaticData[selectedIndex]
      return selectedItem
    }
  })
  const router = useRouter()

  return (
    <Fragment>
      <ul>
        <h3 className="text-gray-400 text-[10px] px-5 py-2.5">
          Suggested Actions
        </h3>
        {suggestActionsStaticData.map((item, index) => (
          <li
            key={index}
            className={`py-2.5 px-5 flex items-center gap-2 hover:bg-[#1A1D21] cursor-pointer`}
            onClick={(e) => {
              e.preventDefault()
              router.push(item.link)
            }}
          >
            <span className={"text-[#9CA3AF]"}>
              <ArrowListIcon />
            </span>
            <a className="!text-[#85BEEF] normal-case no-underline text-xs">
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </Fragment>
  )
}

export default SuggestedAction
